import { pushEvent } from 'src/client/data-layer';

export function trackNewsletterSignup() {
  pushEvent('newsletter_signup');
}
